'use strict';

var inertia = require('../generators/inertia.cjs');
var keyframes = require('../generators/keyframes.cjs');
var index = require('../generators/spring/index.cjs');

const transitionTypeMap = {
    decay: inertia.inertia,
    inertia: inertia.inertia,
    tween: keyframes.keyframes,
    keyframes: keyframes.keyframes,
    spring: index.spring,
};
function replaceTransitionType(transition) {
    if (typeof transition.type === "string") {
        transition.type = transitionTypeMap[transition.type];
    }
}

exports.replaceTransitionType = replaceTransitionType;
//# sourceMappingURL=replace-transition-type.cjs.map
